import React from 'react';
import type { PropsWithChildren } from 'react';

import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

/* For now, this component is a thin wrapper over MUI's LocalizationProvider.
 * We should update the component to fetch the locale package dynamically, based on the user's locale.
 */
export default function LocalizationProvider({ children }: PropsWithChildren) {
  return <MuiLocalizationProvider dateAdapter={AdapterDayjs}>{children}</MuiLocalizationProvider>;
}
